import { createContext, useContext, type ReactNode } from 'react';
import { useNotifications } from '@/hooks/useNotifications';

type NotificationsContextValue = ReturnType<typeof useNotifications>;

const NotificationsContext = createContext<NotificationsContextValue | undefined>(undefined);

export function NotificationsProvider({ children }: { children: ReactNode }) {
  const value = useNotifications(100);
  return (
    <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>
  );
}

export function useAppNotifications() {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useAppNotifications must be used within a NotificationsProvider');
  }
  return context;
}
